import { createFileRoute } from '@tanstack/react-router';
import { PublicRegistrationPage } from '@web/modules/campaigns/registration/public-registration-page';

/** The public registration page of an event (spec 022, rule 24): no session, no app shell. */
export const Route = createFileRoute('/inscricao/$token')({
  component: function Registration() {
    const { token } = Route.useParams();
    return <PublicRegistrationPage token={token} />;
  },
});
